import { cloneElement } from 'react';
import { Facebook, Github, Linkedin, Twitter } from 'styled-icons/fa-brands';
import Image from 'next/image';
import Link from 'next/link';
import { Grid, Card, Paragraph, Title, SubTitle } from '@bidalihq/ui';
import tw from 'tailwind-styled-components';

import team from '@/data/team.json';
import Section from '@/components/section';

const Description = tw(SubTitle)`
  text-2xl
  md:text-2xl
  lg:text-2xl
  xl:text-2xl
  text-center
  mb-16
`;

const Member = tw(Card)`
  h-full
  flex
  flex-col
  items-center
  text-center
`;

const Headshot = tw(Image)`
  rounded-full
  mx-auto
  mb-4
`;

const Name = tw.h2`
  text-brand-primary
  text-xl
  font-normal
`;

const Role = tw.p`
  text-typography-subtle
  text-sm
  font-normal
  mt-0
`;

const Bio = tw(Paragraph)`
  my-4
`;

const SocialLinks = tw.ul`
  items-center
  flex
  list-none
  justify-center
  p-0
  my-4
  gap-4
`;

const SocialLink = tw(Link)`
  cursor-pointer
  inline-block
  no-underline
  scale-100
  text-typography-subtle/50
  transition-all

  hover:scale-110
  hover:text-typography
`;

// const SocialLinks = styled.ul`
//   align-items: center;
//   display: flex;
//   list-style: none;
//   justify-content: center;
//   padding: 0;
//   margin: 1em 0;

//   a, a:hover {
//     color: ${props => props.theme.colors.typography.verySubtle};
//     text-decoration: none;
//   }

//   li + li {
//     margin-left: 1em;
//   }

//   svg {
//     height: 1.5em;
//     width: 1.5em;
//   }
// `;

const Team = () => {
  const icons = {
    facebook: <Facebook />,
    github: <Github />,
    linkedin: <Linkedin />,
    twitter: <Twitter />
  };

  return (
    <Section style={{ paddingTop: 0 }}>
      <Title className="text-center my-12">Our team</Title>
      <Description>Collectively we have built dozens of products for startups to Fortune 100s. We ❤️ open source and have released and contributed to software powering a huge part of the web today.</Description>
      <Grid className="mb-8" columns={[1, 2, 4]}>
        {team.map((member, index) => (
          <Member key={index}>
            <Headshot height={128} src={member.headshot} width={128} />
            <Name>{member.name}</Name>
            <Role>{member.role}</Role>
            {/* <Bio>{member.bio}</Bio> */}
            <SocialLinks>
              {Object.keys(member.social).map(network => (
                <li key={network}>
                  <SocialLink href={member.social[network]}>
                    {cloneElement(icons[network], { className: 'w-6 h-6' })}
                  </SocialLink>
                </li>
              ))}
            </SocialLinks>
          </Member>
        ))}
      </Grid>
    </Section>
  );
};

export default Team;
